import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeAction } from '../orderLifetime.action';
import { OrderLifetimeTranslator } from '../orderLifetime.translator';

type IDependencies = IClientApiDependencySegment;

export const updateOrderLifetimeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.update.started),
  switchMap((params) => {
    const { reject } = params;

    return dependencies.api.updateOrderLifetimeProfile(OrderLifetimeTranslator.toApi(params)).pipe(
      mergeMap(() => {
        return [OrderLifetimeAction.update.done({ params })];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          OrderLifetimeAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
